<template>
  <div>
    <div class="totalPie" style="margin-top: 15px;">
      <div class="tit">
        <p>水位预警</p>
      </div>
      <div class="Pie Piebar" id="ylllc"></div>
    </div>
    <div class="totalPie zrrlist">
      <div class="tit">
        <p>三个责任人清单</p>
      </div>
      <ul>
        <li v-for="(item,i) in qdlist" :key="i">
          <img src="../../common/images/fxxzfzr.png" class="qdimg" v-if="item.code==1" />
          <img src="../../common/images/fxjsfzr.png" class="qdimg" v-if="item.code==2" />
          <img src="../../common/images/fxxc.png" class="qdimg" v-if="item.code==3" />
          <img src="../../common/images/skbm.png" class="qdimg" v-if="item.code==4" />
          <img src="../../common/images/skgl.png" class="qdimg" v-if="item.code==5" />
          <div class="qdtext">
            <p>{{item.textl}}</p>
            <p>
              <span>{{item.name}}</span>
              <span></span>
              <span>{{item.tel}}</span>
            </p>
          </div>
        </li>
      </ul>
    </div>
    <!-- <div class="totalPie">
      <div class="tit">
        <p>防汛巡查责任人</p>
      </div>
      <div class="xczrr">
        <div class="zbtxk">
          <img src="../../common/images/rytx.jpg" alt="" class="zbtx" />
        </div>
        <div class="zrrnames">
          <img src="../../common/images/fxxc.png" class="qdimg" />
          {{fxxczrrName}}
        </div>
        <div class="zrrnames1">
          <img src="../../common/images/tel.png" class="qdimg" />
          {{fxxczrrTel}}
        </div>
      </div>
    </div> -->
    <!-- <div class="zrrlist">
      <div class="tit">
        <p>物资内容</p>
      </div>
      <ul class="wzcontent">
        <li class="wztype" v-for="(item,i) in wzList" :key="i" :class="item.class">
          <p class="titles">{{item.name}}</p>
          <div class="contents">
            <span class="numsss">{{item.num}}</span>
            <span class="titles">个</span>
          </div>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
  import {
    ydbjbxxQuery,
    // xcjlzrr,
    // wznrOrlsqk,
    single
  } from "@/api/api.js";
  export default {
    props: ["gisclick"],
    data() {
      return {
        qdlist: [],
        wzList: [],
        fxxczrrName: "",
        fxxczrrTel: "",
        time: [],
        jiangyul: [],
        liuliang: [],
      };
    },
    mounted() {},
    watch: {
      gisclick(a) {
        let _this = this;
        this.time = [];
        this.jiangyul = [];
        this.liuliang = [];
        if (a.ydbCode) {
          let params = {
            ydbCode: a.ydbCode
          };
          ydbjbxxQuery(params).then((res) => {
            if (res.data[0].ydbFxghzrr) {
              _this.fxxczrrName = res.data[0].ydbFxghzrr;
              _this.fxxczrrTel = res.data[0].ydbFxghzrrlxfs;
            } else {
              _this.fxxczrrName = "xxxxxx";
              _this.fxxczrrTel = "xxxxxxxxxxx";
            }
          });

          // wznrOrlsqk(params).then((res) => {
          //   let mmm = [];
          //   for (let i = 0; i < res.data.length; i++) {
          //     mmm.push({
          //       name: res.data[i].ydbWzMc,
          //       class: 'type' + String(i + 1),
          //       num: res.data[i].ydbGzsl
          //     });
          //   }
          //   _this.wzList = mmm;
          // });

          this.jiekoufun(params);
        }
      },
    },
    methods: {
      jiekoufun(params) {
        let _this = this;
        this.qdlist = [];
        single(params).then((res) => {
          if (res.fangHongKzd[0]) {
            // console.log(res.fangHongKzd[0])
            _this.swLinefun('ylllc', res.fangHongKzd[0]);
          }
          if (res.ydbJisfzr) {
            if (res.ydbJisfzr.ydbFxxzzrr) {
              _this.qdlist.push({
                code: 1,
                textl: "防汛行政责任人",
                name: res.ydbJisfzr.ydbFxxzzrr,
                tel: res.ydbJisfzr.ydbFxxzzrrlxfs,
              });
            };
            if (res.ydbJisfzr.ydbFxjszrr) {
              _this.qdlist.push({
                code: 2,
                textl: "防汛技术责任人",
                name: res.ydbJisfzr.ydbFxjszrr,
                tel: res.ydbJisfzr.ydbFxjszrrlxfs,
              });
            };
            if (res.ydbJisfzr.ydbFxghzrr) {
              _this.qdlist.push({
                code: 3,
                textl: "防汛巡查责任人",
                name: res.ydbJisfzr.ydbFxghzrr,
                tel: res.ydbJisfzr.ydbFxghzrrlxfs,
              });
            };
            if (res.ydbJisfzr.ydbZgbmzrr) {
              _this.qdlist.push({
                code: 4,
                textl: "主管部门负责人",
                name: res.ydbJisfzr.ydbZgbmzrr,
                tel: res.ydbJisfzr.ydbZgbmzrrlxfs,
              });
            };
            if (res.ydbJisfzr.ydbGldw) {
              _this.qdlist.push({
                code: 5,
                textl: "水库管理单位负责人",
                name: res.ydbJisfzr.ydbGldw,
                tel: res.ydbJisfzr.ydbGldwlxfs,
              });
            };
          }
        });
      },
      swLinefun(id, datas) {
        // console.log(datas)
        let Charts = this.$echarts.init(document.getElementById(id));
        if (datas.ydbDqsw && datas.ydbBzsw && datas.ydbJjsw && datas.ydbSfsw) {
          let yAxisData1, yAxisData2, yAxisData3, yAxisData4, yMax;
          let nowriqi = Number(datas.ydbShiJian.split('-')[2]);
          let nowyue = datas.ydbShiJian.split('-')[1];
          let xAxisData = [nowriqi-4, nowriqi-3, nowriqi-2, nowriqi-1, nowriqi, nowriqi+1, nowriqi+2, nowriqi+3];
          if (datas.ydbBzsw) {
            yAxisData1 = datas.ydbBzsw;
          }
          if (datas.ydbJjsw) {
            yAxisData2 = datas.ydbJjsw;
          }
          if (datas.ydbSfsw) {
            yAxisData3 = datas.ydbSfsw;
            yMax = yAxisData3 + 1;
          }
          if (datas.ydbDqsw) {
            yAxisData4 = [0, 0, 0, 0, datas.ydbDqsw, 0, 0, 0];
          }

          let color = [];
          if (datas.ydbDqsw < yAxisData1) {
            color = ["#2da65e"];
          } else if (datas.ydbDqsw >= yAxisData1 && datas.ydbDqsw < yAxisData2) {
            color = ["#dcde10"];
          } else if (datas.ydbDqsw >= yAxisData2 && datas.ydbDqsw < yAxisData3) {
            color = ["#dd9511"];
          } else {
            color = ["#db0a0e"];
            yMax = datas.ydbDqsw + 1;
          }

          const hexToRgba = (hex, opacity) => {
            let rgbaColor = "";
            let reg = /^#[\da-f]{6}$/i;
            if (reg.test(hex)) {
              rgbaColor =
                `rgba(${parseInt("0x" + hex.slice(1, 3))},${parseInt(
              "0x" + hex.slice(3, 5)
            )},${parseInt("0x" + hex.slice(5, 7))},${opacity})`;
            }
            return rgbaColor;
          }

          let option = {
            color: color[0],
            tooltip: {
              trigger: "axis",
              confine: true,
              formatter: function(params) {
                let html = '';
                params.forEach(v => {
                  html +=
                    `<div style="color: #666;font-size: 14px;line-height: 24px">
                        <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${color[0]};"></span>
                        ${v.seriesName}
                        <span style="color:${color[0]};font-weight:700;font-size: 18px;margin-left:5px">${v.value}</span>
                        mm`;
                })
                return html
              },
              extraCssText: 'background: #fff; border-radius: 0;box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);color: #333;',
              axisPointer: {
                type: 'line',
              }
            },
            grid: {
              left: "15%",
              right: "5%",
              top: "15%",
              bottom: 80,
            },
            xAxis: [{
              type: "category",
              boundaryGap: false,
              axisLabel: {
                formatter: nowyue+'-'+'{value}',
                textStyle: {
                  color: "#acb0b6"
                }
              },
              axisLine: {
                lineStyle: {
                  color: "#D9D9D9",
                  fontSize: 16
                }
              },
              data: xAxisData,
            }],
            yAxis: [{
              type: "value",
              max: yMax,
              name: '单位（mm）',
              axisLabel: {
                textStyle: {
                  color: "#acb0b6",
                  fontSize: 16
                }
              },
              nameTextStyle: {
                color: "#acb0b6",
                fontSize: 16,
                lineHeight: 40
              },
              // 分割线
              splitLine: {
                show: false,
                lineStyle: {
                  type: "dashed",
                  color: "#E9E9E9"
                }
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              }
            }],
            series: [{
              name: "保证水位",
              type: "line",
              symbol: "circle",
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(0,244,255,1)' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: 'rgba(0,77,167,1)' // 100% 处的颜色
                  }], false),
                  shadowColor: 'rgba(0,160,221,1)',
                }
              },
              markLine: {
                symbol: "none",
                silent: true,
                lineStyle: {
                  normal: {
                    type: "dashed"
                  }
                },
                label: {
                  position: "start"
                },
                data: [{
                  yAxis: yAxisData1,
                  lineStyle: {
                    width: 1.6560000000000001,
                    color: "yellow"
                  },
                  label: {
                    show: true,
                    position: '',
                  }
                }]
              }
            }, {
              name: "警戒水位",
              type: "line",
              symbol: "circle",
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(0,244,255,1)' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: 'rgba(0,77,167,1)' // 100% 处的颜色
                  }], false),
                  shadowColor: 'rgba(0,160,221,1)',
                }
              },
              markLine: {
                symbol: "none",
                silent: true,
                lineStyle: {
                  normal: {
                    type: "dashed"
                  }
                },
                label: {
                  position: "start"
                },
                data: [{
                  yAxis: yAxisData2,
                  lineStyle: {
                    width: 1.6560000000000001,
                    color: "orange"
                  },
                  label: {
                    show: true,
                    position: '',
                  }
                }]
              }
            }, {
              name: "设防水位",
              type: "line",
              symbol: "circle",
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(0,244,255,1)' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: 'rgba(0,77,167,1)' // 100% 处的颜色
                  }], false),
                  shadowColor: 'rgba(0,160,221,1)',
                }
              },
              markLine: {
                symbol: "none",
                silent: true,
                lineStyle: {
                  normal: {
                    type: "dashed"
                  }
                },
                label: {
                  position: "start"
                },
                data: [{
                  yAxis: yAxisData3,
                  lineStyle: {
                    width: 1.6560000000000001,
                    color: "red"
                  },
                  label: {
                    show: true,
                    position: '',
                  }
                }]
              }
            }, {
              name: "当前水位",
              type: "line",
              smooth: true,
              symbolSize: 5,
              zlevel: 3,
              lineStyle: {
                normal: {
                  color: color[0],
                }
              },
              symbol: 'circle', //数据交叉点样式 (实心点)
              areaStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [{
                        offset: 0,
                        color: hexToRgba(color[0], 0.5)
                      },
                      {
                        offset: 1,
                        color: hexToRgba(color[0], 0.1)
                      }
                    ],
                    false
                  ),
                }
              },
              data: yAxisData4
            }]
          };
          Charts.clear();
          Charts.setOption(option);
        } else {
          Charts.clear();
        }
      },
      eChartsfun(id, times, jyls, lls) {
        // console.log(id, times)
        let Chartsid = this.$echarts.init(document.getElementById(id));
        let option = {
          title: {
            show: false,
            text: "",
            subtext: "",
            left: "center",
            align: "right",
          },
          grid: {
            left: "15%",
            right: "10%",
            top: "15%",
            bottom: 80,
          },
          tooltip: {
            show: true,
            trigger: "axis",
            axisPointer: {
              type: "cross",
              animation: false,
              label: {
                backgroundColor: "#505765",
              },
            },
          },
          legend: {
            icon: "rect",
            show: true,
            data: ["流量", "降雨量"],
            left: "30%",
            right: "50%",
            itemWidth: 20,
            itemHeight: 8,
            textStyle: {
              color: "#fff",
              fontSize: 12,
            },
          },
          /*dataZoom: [
    		    {
    		        show: true,
    		        realtime: true,
    		        start: 65,
    		        end: 85
    		    },
    		    {
    		        type: 'inside',
    		        realtime: true,
    		        start: 65,
    		        end: 85
    		    }
    		],*/
          xAxis: [{
            type: "category",
            boundaryGap: false,
            axisLine: {
              onZero: false
            },
            data: times.map(function(str) {
              return str.replace(" ", "\n");
            }),
            splitLine: {
              lineStyle: {
                // type: 'dashed',
                color: ["#fff"],
              },
            },
            axistick: {
              show: true,
              lineStyle: {
                color: "#224364",
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#ccc",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#acb0b6",
              },
            },
          }, ],
          yAxis: [{
              name: "流量(m^3/s)",
              type: "value",
              max: 200,
              nameTextStyle: {
                color: "#acb0b6",
              },
              splitLine: {
                lineStyle: {
                  color: "#ccc",
                },
              },
              axistick: {
                show: true,
                lineStyle: {
                  color: "#224364",
                },
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#1e5d73",
                },
              },
              axisLabel: {
                textStyle: {
                  color: "#acb0b6",
                },
              },
            },
            {
              name: "降雨量(mm)",
              nameLocation: "start",
              max: 200,
              type: "value",
              inverse: true,
              splitLine: {
                //线的颜色
                lineStyle: {
                  color: ["#1e5d73"],
                },
              },
              axistick: {
                show: true,
                lineStyle: {
                  color: "#224364",
                },
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#ccc",
                },
              },
              axisLabel: {
                textStyle: {
                  color: "#acb0b6",
                },
              },
            },
          ],
          series: [{
              smooth: true,
              symbol: "circle",
              symbolSize: 2,
              name: "降雨量",
              type: "line",
              yAxisIndex: 1,
              areaStyle: {},
              lineStyle: {
                width: 1,
                color: "#2da65e",
              },
              itemStyle: {
                normal: {
                  color: "#2da65e",
                },
              },
              areaStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [{
                        offset: 0,
                        color: "rgba(45,166,94,1)",
                      },
                      {
                        offset: 1,
                        color: "rgba(45,166,94,0.3)",
                      },
                    ],
                    false
                  ),
                  shadowColor: "rgba(195,230,255,0.1)",
                  shadowBlur: 20,
                },
              },
              emphasis: {
                focus: "series",
              },
              markArea: {
                silent: true,
                itemStyle: {
                  opacity: 0.3,
                },
                data: [
                  [{
                      xAxis: "2009/9/10\n7:00",
                    },
                    {
                      xAxis: "2009/9/20\n7:00",
                    },
                  ],
                ],
              },
              data: jyls,
            },
            {
              smooth: true,
              symbol: "circle",
              symbolSize: 2,
              name: "流量",
              type: "line",
              areaStyle: {},
              lineStyle: {
                width: 1,
                color: "#00b3fe",
              },
              itemStyle: {
                normal: {
                  color: "#00b3fe",
                },
              },
              areaStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [{
                        offset: 0,
                        color: "rgba(0,179,254,0.1)",
                      },
                      {
                        offset: 1,
                        color: "rgba(0,179,254,1)",
                      },
                    ],
                    false
                  ),
                  shadowColor: "rgba(195,230,255,0.1)",
                  shadowBlur: 20,
                },
              },
              emphasis: {
                focus: "series",
              },
              markArea: {
                silent: true,
                itemStyle: {
                  opacity: 0.3,
                },
                data: [
                  [{
                      xAxis: "2009/9/12\n7:00",
                    },
                    {
                      xAxis: "2009/9/22\n7:00",
                    },
                  ],
                ],
              },
              data: lls,
            },
          ],
        };
        Chartsid.clear();
        Chartsid.setOption(option);
      },
    },
  };
</script>

<style scoped>
  .totalPie,
  .zrrlist {
    width: 100%;
    height: 300px;
    background: url(../../common/images/contentborder.png) no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;
  }

  .zrrlist {
    margin-top: 15px;
  }

  .zrrlist ul {
    width: 90%;
    margin: 0 auto;
  }

  .zrrlist ul li {
    width: 100%;
    height: 45px;
    border-bottom: 1px solid #098dc7;
    cursor: pointer;
  }

  .Pie {
    width: 90%;
    margin: 0 auto;
    height: 300px;
  }

  .qdtext {
    width: calc(100% - 44px);
    width: -webkit-calc(100% - 44px);
    width: -moz-calc(100% - 44px);
    float: right;
    height: 45px;
    margin-left: 10px;
  }

  .qdtext p:nth-child(1) {
    color: #00b3fe;
    font-size: 14px;
    width: 1005;
    line-height: 12px;
    margin-top: 7px;
  }

  .qdtext p:nth-child(2) {
    color: #fdfdfd;
    font-size: 14px;
    width: 1005;
    line-height: 12px;
    margin-top: 5px;
  }

  .qdtext p:nth-child(2) span:nth-child(1) {
    margin-right: 8px;
    border-right: 1px solid #fdfdfd;
    padding-right: 8px;
    font-size: 14px;
    display: block;
    float: left;
    height: 12px;
  }

  .qdtext p:nth-child(2) span:nth-child(2) {
    display: block;
    width: 12px;
    height: 12px;
    background: url(../../common/images/tel.png) no-repeat center;
    background-size: 100% 100%;
    float: left;
    margin-right: 6px;
  }

  .tit {
    padding-bottom: 5px;
    border-bottom: 1px solid #098dc7;
  }

  .xczrr {
    width: 90%;
    height: 220px;
    margin-left: 5%;
    margin-top: 10px;
  }

  .zbtxk {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    margin-left: 50%;
    margin-top: 50px;
    transform: translate(-50%);
    overflow: hidden;
  }

  .zbtx {
    width: 100%;
  }

  .zrrnames {
    height: 30px;
    margin-left: 50%;
    margin-top: 20px;
    transform: translate(-50%);
    color: #fff;
    font-size: 16px;
    text-align: center;
  }

  .zrrnames1 {
    height: 30px;
    margin-left: 50%;
    transform: translate(-50%);
    color: #fff;
    font-size: 16px;
    text-align: center;
  }

  .qdimg {
    position: relative;
    top: 4px;
    width: 20px;
    height: 20px;
    /* margin-top: 5px; */
    margin-right: 5px;
  }

  .wzcontent {
    width: 90%;
    height: 280px;
    margin-left: 5%;
    margin-top: 10px;
  }

  .wztype {
    width: 42%;
    height: 60px;
    margin-left: 5%;
    margin-top: 10px;
    float: left;
  }

  .type1 {
    color: rgba(48, 144, 198, 1);
    border: 1px solid rgba(48, 144, 198, 1);
    background-color: rgba(48, 144, 198, 0.2);
  }

  .type2 {
    color: rgba(51, 198, 96, 1);
    border: 1px solid rgba(51, 198, 96, 1);
    background-color: rgba(51, 198, 96, 0.2);
  }

  .type3 {
    color: rgba(241, 228, 114, 1);
    border: 1px solid rgba(241, 228, 114, 1);
    background-color: rgba(241, 228, 114, 0.2);
  }

  .type4 {
    color: rgba(179, 80, 194, 1);
    border: 1px solid rgba(179, 80, 194, 1);
    background-color: rgba(179, 80, 194, 0.2);
  }

  .type5 {
    color: rgba(226, 144, 112, 1);
    border: 1px solid rgba(226, 144, 112, 1);
    background-color: rgba(226, 144, 112, 0.2);
  }

  .contents {
    float: right;
    padding-right: 10px;
    padding-top: 5px;
  }

  .titles {
    color: #fff;
    line-height: 30px;
    padding-left: 5px;
    font-size: 14px;
  }

  .numsss {
    font-size: 18px;
    font-weight: bold;
  }
</style>
